import { memo, type ReactNode } from 'react';

import { useBreakpointsContext } from '@air/provider-media-query';

export type HeaderActionsProps = {
  actions?: ReactNode;
};

export const PrivateHeaderActions = memo(({ actions }: HeaderActionsProps) => {
  const { isAboveMediumScreen } = useBreakpointsContext();

  if (!isAboveMediumScreen) return null;

  if (!actions) return null;

  return <div className="flex shrink-0">{actions}</div>;
});

PrivateHeaderActions.displayName = 'HeaderActions';
